<template>
  <div class="event-ranking">
    <!--    <div class="header">
          <div class="header_section">
            <router-link to="/profile" class="header_element header_icone mobile">
              &lt;!&ndash;          <span class="icon icon-left-arrow icon-lg"></span>&ndash;&gt;
              <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

            </router-link>
            <h1 class="header_element">{{events.event_name}} Classement</h1>
          </div>
        </div>-->
    <div class="content_container">
      <div class="ranking_container">

        <div class="head_rank">
          <span class="rank">#</span>
          <span>avatar</span>
          <span>username</span>
          <span>point</span>
        </div>

        <div class="user_rank" v-for="(rank,index) in ranking"
             :class="index+1===1?'first':index+1===2?'second':index+1===3?'third':''">
          <span class="rank">{{ index }}</span>
          <img width="20%" :src="rank.id_user.avatar" alt="">
          <span>{{ rank.id_user.name }}</span>
          <span>{{ rank.pts }}</span>
        </div>

        <div class="user_rank " v-for="rank in 10" :class="rank===1?'first':rank===2?'second':rank===3?'third':''"
             v-if="!ranking || ranking.length < 1">
          <span class="rank">{{ rank }}</span>
          <img :src="user.avatar" alt="">
          <span> - - - - </span>
          <span>0</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {store} from '../../../store/store';
import {mapState, mapActions} from "vuex";

import LightBox from 'vue-image-lightbox'

export default {
  name: 'gallery',
  props: [
    'event',
  ],
  components: {
    LightBox,
  },
  data() {
    return {
      ranking: null,

    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    ...mapActions([
      'getRanking'
    ]),
  },
  mounted() {
    // this.medias = localStorage.getItem('medias')
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});
    this.getRanking(this.event.id).then(res => this.ranking = res)
  }
}
</script>

<style scoped>
@import "https://use.fontawesome.com/releases/v5.0.6/css/all.css";
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.header_section {
  display: flex;
  align-items: center;
  text-align: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}

.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.user_ranking {
  display: flex;
  justify-content: space-between;
  width: 30%;
  border: 1px solid var(--main-color);
  border-radius: 5px;
  padding: 5px 10px;
}

.content_container {
  margin: auto;
  background: #fff;
  border-radius: 10px;
  /*border:2px solid #00d6ff;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 10;
  min-height: 60vh;
}

.content_container .ranking_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  height: 100%;
}

.content_container .ranking_container .head_rank {
  width: 80%;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  align-items: center;
  border-radius: 10px;
  margin: 10px;
  background: rgba(255, 255, 255, 0.6);
  position: relative;
  max-height: 45px;
}

.content_container .ranking_container .user_rank {
  width: 80%;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  align-items: center;
  border: 1px solid var(--main-color-darkness);
  border-radius: 10px;
  margin: 10px;
  background: rgba(255, 255, 255, 0.6);
  position: relative;
  max-height: 45px;
}

.content_container .ranking_container .user_rank img {
  border-radius: 50%;
  width: 45px;
}

.content_container .ranking_container .user_rank.first:after {
  display: block;
  position: absolute;
  content: "";
  top: -10px;
  left: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 20px);
  background: rgba(244, 228, 44, 0.55);
  border-radius: 10px;
  z-index: -1;
}

.content_container .ranking_container .user_rank.second:after {
  display: block;
  position: absolute;
  content: "";
  top: -10px;
  left: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 20px);
  background: rgba(192, 192, 192, 0.55);
  border-radius: 10px;
  z-index: -1;
}

.content_container .ranking_container .user_rank.third:after {
  display: block;
  position: absolute;
  content: "";
  top: -10px;
  left: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 20px);
  background: rgba(196, 156, 72, 0.55);
  border-radius: 10px;
  z-index: -1;
}

.rank {
  position: absolute;
  left: -20px;
}

.mobile {
  display: none;
}

@media screen and (max-width: 750px) {
  .media {
    width: 30%;
  }

  .mobile {
    display: block;
  }

  .media img {
    height: 100%;
  }
}

.duration, .trash, .share {
  position: absolute;
  bottom: 8px;
  padding: 2px;
  color: #fff;
  transition: .3s;

}

.trash:hover, .share:hover {
  cursor: pointer;
  color: #00d6ff;
}

.duration {
  right: 5px;
}

.trash {
  left: 5px;
}

.share {
  right: 5px;
}

</style>
<style src="../../../asset/lightBoxStyle.css"></style>
